"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Squid = void 0;
const squid_types_1 = require("@0xsquid/squid-types");
const HttpAdapter_1 = __importDefault(require("./adapter/HttpAdapter"));
const EthersAdapter_1 = require("./adapter/EthersAdapter");
const constants_1 = require("./constants");
const TokensChains_1 = require("./TokensChains");
const handlers_1 = require("./handlers");
const erc20_json_1 = __importDefault(require("./abi/erc20.json"));
const baseUrl = "https://testnet.api.squidrouter.com/";
const ethersAdapter = new EthersAdapter_1.EthersAdapter();
class Squid extends TokensChains_1.TokensChains {
    constructor(config = {}) {
        super();
        this.handlers = {
            evm: new handlers_1.EvmHandler(),
            cosmos: new handlers_1.CosmosHandler()
        };
        this.initialized = false;
        this.isInMaintenanceMode = false;
        this.httpInstance = new HttpAdapter_1.default({
            baseUrl: config?.baseUrl || baseUrl,
            config,
            headers: {
                "x-integrator-id": config.integratorId || "squid-sdk"
            }
        });
        this.config = {
            baseUrl: config?.baseUrl || baseUrl,
            ...config
        };
    }
    setConfig(config) {
        this.httpInstance = new HttpAdapter_1.default({
            baseUrl: config?.baseUrl || baseUrl,
            config,
            headers: {
                "x-integrator-id": config.integratorId || "squid-sdk"
            }
        });
        this.config = {
            baseUrl: config?.baseUrl || baseUrl,
            ...config
        };
    }
    async init() {
        const response = await this.httpInstance.get("v2/sdk-info");
        if (response.status != 200) {
            throw new Error("SDK initialization failed");
        }
        this.tokens = response.data.tokens;
        this.chains = response.data.chains;
        this.isInMaintenanceMode = response.data.isInMaintenanceMode;
        this.maintenanceMessage = response.data.maintenanceMessage;
        this.initialized = true;
    }
    // PUBLIC METHODS
    // TODO: ADD STATUS TYPE
    async getStatus(params) {
        const response = await this.httpInstance.axios.get("/v1/status", {
            params,
            headers: {
                ...(this.httpInstance.axios.defaults.headers.common &&
                    this.httpInstance.axios.defaults.headers.common),
                ...(params.requestId && { "x-request-id": params.requestId }),
                ...(params.integratorId && { "x-integrator-id": params.integratorId })
            }
        });
        return response.data;
    }
    async getRoute(params) {
        this.validateInit();
        const response = await this.httpInstance.get("v2/route", {
            params
        });
        if (response.status != 200) {
            throw new Error(response.data.error);
        }
        return response.data;
    }
    async executeRoute(data) {
        this.validateInit();
        this.validateTransactionRequest(data.route);
        const params = this.populateRouteParams(data.route.params, data.signer);
        switch (params.fromChain.chainType) {
            case squid_types_1.ChainType.EVM:
                return this.handlers.evm.executeRoute({ data, params });
            case squid_types_1.ChainType.COSMOS:
                return this.handlers.cosmos.executeRoute({ data, params });
            default:
                throw new Error(`Method not supported given chain type ${params.fromChain.chainType}`);
        }
    }
    async isRouteApproved({ route, sender }) {
        this.validateInit();
        this.validateTransactionRequest(route);
        const params = this.populateRouteParams(route.params);
        switch (params.fromChain.chainType) {
            case squid_types_1.ChainType.EVM:
                return await this.handlers.evm.isRouteApproved({
                    sender,
                    params,
                    target: route.transactionRequest.target
                });
            default:
                throw new Error(`Method not supported given chain type ${params.fromChain.chainType}`);
        }
    }
    async approveRoute(data) {
        this.validateInit();
        this.validateTransactionRequest(data.route);
        const params = this.populateRouteParams(data.route.params, data.signer);
        switch (params.fromChain.chainType) {
            case squid_types_1.ChainType.EVM:
                return this.handlers.evm.approveRoute({ data, params });
            default:
                throw new Error(`Method not supported given chain type ${params.fromChain.chainType}`);
        }
    }
    // TODO: IS THIS METHOD GONNA BE EVM ONLY ?
    getRawTxHex(data) {
        this.validateInit();
        this.validateTransactionRequest(data.route);
        return this.handlers.evm.getRawTxHex({ ...data });
    }
    // INTERNAL PRIVATES METHODS
    validateInit() {
        if (!this.initialized) {
            throw new Error("SquidSdk must be initialized! Please call the SquidSdk.init method");
        }
    }
    populateRouteParams(params, signer) {
        const { fromChain, toChain, fromToken, toToken } = params;
        const _fromChain = this.getChainData(fromChain);
        const _toChain = this.getChainData(toChain);
        const _fromToken = this.getTokenData(fromToken, fromChain);
        const _toToken = this.getTokenData(toToken, toChain);
        const fromProvider = ethersAdapter.rpcProvider(_fromChain.rpc);
        const fromIsNative = _fromToken.address === constants_1.nativeTokenConstant;
        let fromTokenContract;
        if (!fromIsNative) {
            fromTokenContract = ethersAdapter.contract(_fromToken.address, erc20_json_1.default, signer || fromProvider);
        }
        return {
            ...params,
            fromChain: _fromChain,
            toChain: _toChain,
            fromToken: _fromToken,
            toToken: _toToken,
            fromTokenContract,
            fromProvider,
            fromIsNative
        };
    }
    validateTransactionRequest(route) {
        if (!route.transactionRequest) {
            throw new Error("transactionRequest param not found in route object");
        }
    }
}
exports.Squid = Squid;
//# sourceMappingURL=index.js.map